module.exports = __webpack_public_path__ + "media/images/shark/Shark5-p-800-39120ebb539db9efe4d286f208cadd54.png";